import React from 'react';
import { faSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, Button, Card } from 'react-bootstrap';
import Certificate from './Icon/Certificate';

const CertificateItem = ({ index, certificate }) => {
    return (
        certificate ? (
            <Card>
                <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey={index} className='text-left'>
                        <FontAwesomeIcon icon={faSignature} />  Firmado por <strong>{ certificate.name }</strong>
                    </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={index}>
                    <Card.Body>
                    <div className="media">
                        <Certificate size={32} />
                        <div className="media-body">
                            <h5 className="mt-0">Certificado</h5>
                            {
                                certificate.items.map(item => (
                                    <span style={{ display: 'block'}}>{ item }</span>
                                ))
                            }
                        </div>
                    </div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        ) : null
    );
};

export default CertificateItem;